import React from 'react'
import { constants } from 'common/helpers'

import VerifyShippingAddressBaseModal from '../VerifyShippingAddressBaseModal/VerifyShippingAddressBaseModal'

import messages from './messages'


const VerifyShippingAddressModal: React.FunctionComponent = () => (
  <VerifyShippingAddressBaseModal
    name={constants.modals.humble.verifyShippingAddress}
    text={messages.text}
    openEventName={constants.snowplowEvents.verifyShippingAddressPopup.open}
    confirmEventName={constants.snowplowEvents.verifyShippingAddressPopup.correctClick}
  />
)


export default VerifyShippingAddressModal
